import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import SelectSearch from "react-select-search";
import axios from "axios";

const SelectSearchInput = ({
  token,
  setToken,
  selectedOutlet,
  setSelectedOutlet,
  setCompany,
}) => {
  let navigate = useNavigate();
  let url = process.env.REACT_APP_BASE_URL;
  const [listOutlet, setListOutlet] = useState([]);
  const user_id = sessionStorage.getItem('userID');

  useEffect(() => {
    let tokenCheck = sessionStorage.getItem("token");
    if (!tokenCheck) {
      navigate("/");
    } else {
      setToken(sessionStorage.getItem("token"));
    }
  }, [navigate, setToken]);

  useEffect(() => {
    if (token) {
      axios
        .post(`${url}/outlets`, { token: token, user_id: user_id })
        .then((response) => {
          setListOutlet(response.data);

          if (!selectedOutlet && response.data.length > 0) {
            setSelectedOutlet(response.data[0]?.value);
            setCompany(response.data[0]?.company);
          }
        })
        .catch((error) => {
          console.log(error);
        });
    }
  }, [token, url, user_id]);

  useEffect(() => {
    if (selectedOutlet) {
      const selectedOutletObj = listOutlet.find(
        (outlet) => outlet.value === selectedOutlet
      );

      if (selectedOutletObj) {
        const {
          address,
          company,
          logo,
          name,
          pan_no,
          phone_no,
        } = selectedOutletObj;

        const setSanitizedItem = (key, value) => {
          const sanitized =
            typeof value === 'string' && value.trim() !== ''
              ? value.trim()
              : null;

          sessionStorage.setItem(key, sanitized ?? '');
        };

        setSanitizedItem("selectedAddress", address);
        setSanitizedItem("selectedCompany", company);
        setSanitizedItem("selectedLogo", logo);
        setSanitizedItem("selectedName", name);
        setSanitizedItem("selectedPan", pan_no);
        setSanitizedItem("selectedPhone", phone_no);
      }
    }
  }, [selectedOutlet, listOutlet]);

  return (
    <div className="select-search">
      <SelectSearch
        defaultValue={selectedOutlet}
        search
        placeholder={"Select Outlet Name"}
        onChange={(event) => {
          const selectedOutletValue = event;
          const selectedOutletObj = listOutlet.find(
            (outlet) => outlet.value === selectedOutletValue
          );

          if (selectedOutletObj) {
            const { address, company, logo, name } = selectedOutletObj;

            sessionStorage.setItem("selectedAddress", address);
            sessionStorage.setItem("selectedCompany", company);
            sessionStorage.setItem("selectedLogo", logo);
            sessionStorage.setItem("selectedName", name);

            setSelectedOutlet(selectedOutletValue);
            setCompany(selectedOutletObj.company);
          }
        }}
        options={listOutlet}
      />

    </div>
  );
};

export default SelectSearchInput;
